module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zyQ3jL/images/Cover.jpg?1702297693303",
      "alt": "This image is the cover for the book Deadline"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Deadline\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Jack McMorrow, a former "), _c('i', [_vm._v("New York Times")]), _vm._v(" reporter has come to Maine to run the weekly local newspaper. When a seemingly friendless and ineffective staff photographer is found drowned in the river, McMorrow wonders why, and wonders why the local police don't wonder more.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gerry Boyle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Gerry Boyle began his writing career working for newspapers—a start he calls the best training ground ever. After attending Colby College, he knocked around at various jobs, including stints as a roofer, a postman, and a manuscript reader at a big New York publisher. He began his newspaper career in the paper mill town of Rumford, Maine. There was a lot of small-town crime in Rumford and Gerry would later mine his Rumford time for his first novel, "), _c('i', [_vm._v("Deadline")]), _vm._v(" After a few months he moved on to the "), _c('i', [_vm._v("Morning Sentinel")]), _vm._v(" in Waterville, where editors gave him a thrice-weekly column and he wrote about stuff he saw in police stations and courtrooms in the towns and cities of Maine. All the while he was also typing away on a Smith-Corona electric typewriter, writing "), _c('i', [_vm._v("Deadline")]), _vm._v(" which marked his debut s a novelist in 1993. Since finishing "), _c('i', [_vm._v("Deadline")]), _vm._v(", he has written eight additional Jack McMorrow stories with a tenth, "), _c('i', [_vm._v("Once Burned")]), _vm._v(", scheduled for release in May 2015.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Islandport Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0